.overlay {
  position: fixed;
  inset: 0;
  background: var(--overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-6);
  z-index: 1000;
}

/* Матовое стекло: подложка размывается, панель просвечивает. Всё под
   @supports — там, где backdrop-filter не поддерживается, остаётся прежняя
   плотная заливка, а не полупрозрачная панель поверх читаемого текста. */
@supports ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  .overlay {
    -webkit-backdrop-filter: blur(6px) saturate(120%);
    backdrop-filter: blur(6px) saturate(120%);
    background: color-mix(in srgb, var(--overlay) 65%, transparent);
  }

  .panel {
    -webkit-backdrop-filter: blur(18px) saturate(140%);
    backdrop-filter: blur(18px) saturate(140%);
    background: color-mix(in srgb, var(--surface) 86%, transparent);
    border-color: color-mix(in srgb, var(--border) 70%, transparent);
  }

  /* Полосы шапки и подвала на просвечивающей панели дают грязь: под ними видно
     интерфейс, и сплошная заливка выглядит наклейкой. Оставляем только линию. */
  .header,
  .footer {
    background: transparent;
  }
}

.panel {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - var(--sp-8) * 2);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--glass-rim), var(--shadow-modal);
}

/* Ободок медленно переливается, пока окно открыто: голубо-серый градиент ходит
   вдоль рамки. Рисуется отдельным слоем и вырезается маской в полоску толщиной
   в пиксель — border градиентом залить нельзя.

   Переливание намеренно низкоконтрастное: рамка должна дышать, а не мигать и
   не спорить с содержимым. */
.panel::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 2;
  padding: 1px;
  border-radius: inherit;
  background: linear-gradient(
    115deg,
    var(--border) 0%,
    var(--flight) 22%,
    var(--border-strong) 42%,
    var(--flight) 64%,
    var(--border) 100%
  );
  background-size: 300% 300%;
  /* content-box за вычетом всей площади — остаётся ровно рамка в 1px. */
  -webkit-mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  mask-composite: exclude;
  pointer-events: none;
  animation: sheen 7s ease-in-out infinite;
}

@keyframes sheen {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@media (prefers-reduced-motion: reduce) {
  /* Движение выключено, но градиент остаётся: рамка просто перестаёт ходить. */
  .panel::before {
    animation: none;
  }
}

.panel.wide {
  max-width: 760px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-5) var(--sp-6);
  border-bottom: 1px solid var(--border);
  flex: 0 0 auto;
}

.title {
  font-size: var(--fs-lg);
  font-weight: 600;
  color: var(--text);
}

.closeBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  background: transparent;
  border: var(--bw) solid transparent;
  border-radius: var(--radius);
  cursor: pointer;
  font-size: var(--fs-md);
  color: var(--text-2);
}

.closeBtn:hover {
  background: var(--surface-2);
  color: var(--text);
}

.body {
  padding: var(--sp-6);
  overflow-y: auto;
  flex: 1 1 auto;
  color: var(--text);
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--sp-4);
  padding: var(--sp-5) var(--sp-6);
  border-top: 1px solid var(--border);
  flex: 0 0 auto;
}

/* ── Безрамочный вариант: шапку рисует содержимое (см. окно входа) ──────── */
.panel.bare {
  max-width: 420px;
  position: relative;
  overflow: hidden;
}

.closeFloating {
  position: absolute;
  top: var(--sp-4);
  right: var(--sp-4);
  z-index: 1;
}

.bodyBare {
  padding: 0;
}
